export const equipment = {
  seo: {
    title: 'Equipment Rental | LensBank Professional Camera Gear',
    description: 'Over 1,000+ professional cinema and photography equipment available for rent: cameras, lenses, lighting, audio, monitors, stabilizers and more. Multi-brand selection, flexible rental periods, expert support.',
    keywords: 'equipment rental,camera rental,lens rental,lighting gear,audio equipment,film gear'
  },
  hero: {
    title: 'Professional Equipment Rental',
    subtitle: 'Over 1,000+ professional cinema and photography gear items for every production need'
  },
  categories: {
    title: 'Categories',
    all: 'All',
    camera: 'Camera',
    lens: 'Lens',
    lighting: 'Lighting',
    audio: 'Audio',
    monitor: 'Monitor',
    stabilizer: 'Stabilizer',
    grip: 'Grip & Tripod',
    accessories: 'Accessories'
  },
  subcategories: {
    all: 'All',
    cinema: 'Cinema Camera',
    mirrorless: 'Mirrorless',
    camcorder: 'Camcorder',
    action: 'Action Camera',
    prime: 'Prime Lens',
    zoom: 'Zoom Lens',
    led: 'LED Light',
    hmi: 'HMI Light',
    shotgun: 'Shotgun Mic',
    wireless: 'Wireless Mic',
    production: 'Production Monitor',
    gimbal: 'Gimbal'
  },
  filters: {
    title: 'Filters',
    category: 'Category',
    subcategory: 'Subcategory',
    brand: 'Brand',
    allBrands: 'All Brands',
    location: 'Available Location',
    priceRange: 'Price Range',
    availability: 'Availability',
    available: 'Available',
    unavailable: 'Rented Out',
    all: 'All',
    reset: 'Reset Filters',
    results: 'results',
    sortBy: 'Sort By',
    sortDefault: 'Default',
    sortPriceLow: 'Price: Low to High',
    sortPriceHigh: 'Price: High to Low',
    sortName: 'Name'
  },
  list: {
    perDay: '/day',
    perWeek: '/week',
    viewDetails: 'View Details',
    addToCart: 'Add to Booking',
    outOfStock: 'Rented Out',
    inStock: 'Available',
    dailyRate: 'Daily Rate',
    available: 'Available',
    selectCategory: 'Select an Equipment Category',
    selectCategoryDesc: 'Choose a category from the bar above to browse available rental equipment.',
    noProducts: 'No equipment in this category',
    noProductsDesc: 'Try another category or adjust your filters',
    deposit: 'Deposit'
  },
  tags: {
    // Canonical machine keys only
    hot: 'Popular',
    new: 'New Arrival',
    incoming: 'Coming Soon',
    staff_required: 'Staff Required',
    crew_only: 'Crew Only',
    featured: 'Featured'
  },
  detail: {
    specifications: 'Specifications',
    pricing: 'Pricing',
    dailyRate: 'Daily',
    weeklyRate: 'Weekly',
    monthlyRate: 'Monthly',
    deposit: 'Deposit',
    requirements: 'Rental Requirements',
    requirementsText: 'Valid ID and a credit card are required as deposit. Companies must provide a business registration certificate.',
    notes: 'Important Notes',
    notesText: 'Please return all equipment by the agreed time. Late returns incur additional charges. Any damage will be charged at replacement cost.',
    quantity: 'Quantity',
    rentalPeriod: 'Rental Period',
    startDate: 'Pickup Date',
    endDate: 'Return Date',
    pickupLocation: 'Pickup Location',
    selectLocation: 'Select Location',
    addToBooking: 'Add to Booking Cart',
    bookNow: 'Book Now',
    available: 'Available',
    unavailable: 'Rented Out',
    backToList: 'Back to List',
    booking: 'Reserve Equipment',
    days: 'days',
    stock: 'Stock',
    units: 'units',
    totalEstimate: 'Estimated Total',
    addToCart: 'Add to Booking Cart',
    backToProducts: 'Back to Equipment',
    noWeeklyPrice: 'No weekly discount',
    stockByLocation: 'Stock by Location'
  },
  related: {
    title: 'Related Equipment',
    subtitle: 'You might also be interested in',
    viewAll: 'View More',
    noRelated: 'No related equipment available'
  },
  booking: {
    title: 'Booking Cart',
    empty: 'Your booking cart is empty',
    item: 'Item',
    quantity: 'Qty',
    period: 'Period',
    price: 'Price',
    total: 'Total',
    remove: 'Remove',
    clear: 'Clear All',
    checkout: 'Submit Booking',
    continueBooking: 'Continue Shopping'
  }
};
